import {getRandomArbitrary, getRandomInt} from "../../util/color.js";
import {weather_sheet as cloud_sheet} from "./sprites.js";
import {Container} from "pixi.js";


export function makeCloudTextureSprite() {
    let textureNum = getRandomInt(1, 10);
    return cloud_sheet.textures[`cloud${textureNum}.png`];
}

export function makePrecipCloudTextureSprite() {
    let textureNum = getRandomInt(1, 6);
    return cloud_sheet.textures[`cloud_precip${textureNum}.png`];
}


export function makeCloudTexture(card) {
    // ==== 2 MIDDLE PARTS =======
    const cloudMiddle1Height = getRandomInt(card.sizes.card.width / 7, card.sizes.card.width / 5.5);
    const cloudMiddle2Height = getRandomInt(card.sizes.card.width / 7, card.sizes.card.width / 5.5);
    const cloudMiddle1Width = cloudMiddle1Height * getRandomArbitrary(1.1, 1.5);
    const cloudMiddle2Width = cloudMiddle2Height * getRandomArbitrary(1.1, 1.5);

    const color = 0xffffff;

    // ===== LEFT PART OF THE CLOUD =====
    const cloudLeftHeight = cloudMiddle1Height * getRandomArbitrary(0.5, 0.7);
    const cloudLeftWidth = cloudLeftHeight * getRandomArbitrary(1, 1.4);
    const cloudLeftOffsetTop = cloudLeftHeight * getRandomArbitrary(-0.3, 0.3);
    let cloudLeft = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(0, cloudLeftOffsetTop, cloudLeftWidth, cloudLeftHeight);

    let cloudMiddle1 = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(cloudLeftWidth, 0, cloudMiddle1Width, cloudMiddle1Height);

    let cloudMiddle2 = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(cloudLeftWidth + cloudMiddle1Width, 0, cloudMiddle2Width, cloudMiddle2Height);

    // ===== RIGHT PART OF THE CLOUD
    const cloudRightHeight = cloudMiddle2Height * getRandomArbitrary(0.5, 0.7);
    const cloudRightWidth = cloudRightHeight * getRandomArbitrary(1, 1.4);
    const cloudRightOffsetTop = cloudRightHeight * getRandomArbitrary(-0.3, 0.3);
    let cloudRight = new Graphics()
        .beginFill(color, 1)
        .drawEllipse(cloudLeftWidth + cloudMiddle1Width + cloudMiddle2Width, cloudRightOffsetTop, cloudRightWidth, cloudRightHeight);

    let container = new Container();
    container.addChild(cloudMiddle1);
    container.addChild(cloudMiddle2);
    container.addChild(cloudLeft);
    container.addChild(cloudRight);

    return card.renderer.generateTexture(container);
}


export function makePrecipitationCloudTextures(card) {
    // ==== 2 MIDDLE PARTS =======
    const cloudHeight = getRandomInt(card.sizes.card.height / 14, card.sizes.card.height / 12);
    const cloudMiddle1Width = cloudHeight * getRandomArbitrary(1.3, 1.8);
    const cloudMiddle2Width = cloudHeight * getRandomArbitrary(1.3, 1.8);
    const cloudLeftWidth = cloudHeight * getRandomArbitrary(1.3, 1.8);

    const color = 0xffffff;

    // starts at 0 -- x, y (first 2 args) are center of the ellipse
    let cloudLeft = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(cloudLeftWidth, 0, cloudLeftWidth, cloudHeight);
    let cloudLeftCopy = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(cloudLeftWidth, 0, cloudLeftWidth, cloudHeight);

    // without multiplied would be half intersection
    let offsetMiddle1 = (cloudLeftWidth + cloudMiddle1Width) * getRandomArbitrary(1.2, 1.4);

    let cloudMiddle1 = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetMiddle1, 0, cloudMiddle1Width, cloudHeight);
    let cloudMiddle1Copy = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetMiddle1, 0, cloudMiddle1Width, cloudHeight);

    let offsetMiddle2 = offsetMiddle1 + cloudMiddle2Width * getRandomArbitrary(1.2, 1.4);

    let cloudMiddle2 = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetMiddle2, 0, cloudMiddle2Width, cloudHeight);
    let cloudMiddle2Copy = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetMiddle2, 0, cloudMiddle2Width, cloudHeight);

    const cloudRightWidth = (card.sizes.card.width - offsetMiddle2) / 2;
    let offsetRight = offsetMiddle2 + cloudRightWidth;
    let cloudRight = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetRight, 0, cloudRightWidth, cloudHeight);
    let cloudRightCopy = new PIXI.Graphics()
        .beginFill(color, 1)
        .drawEllipse(offsetRight, 0, cloudRightWidth, cloudHeight);

    let cloud1 = new Container();
    cloud1.addChild(cloudMiddle1);
    cloud1.addChild(cloudMiddle2);
    cloud1.addChild(cloudLeft);
    cloud1.addChild(cloudRight);
    let cloud2 = new Container();
    cloud2.addChild(cloudMiddle1Copy);
    cloud2.addChild(cloudMiddle2Copy);
    cloud2.addChild(cloudLeftCopy);
    cloud2.addChild(cloudRightCopy);
    let tx1 = card.renderer.generateTexture(cloud1);
    let tx2 = card.renderer.generateTexture(cloud2);

    return [tx1, tx2];
}